import { Link } from "react-router-dom";
import { TrendingUp, Twitter, Linkedin, Instagram, Github, Mail, Phone, MapPin } from "lucide-react";
import { LEGAL_INDEX, CONTACT_BLOCK } from "@/pages/legal/content";

const cols = [
  {
    title: "Services",
    links: [
      { label: "Website Design", href: "/services" },
      { label: "SEO Optimization", href: "/services" },
      { label: "AEO & GEO", href: "/services" },
      { label: "Landing Pages", href: "/services" },
      { label: "Branding", href: "/services" },
      { label: "Content Strategy", href: "/services" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", href: "/about" },
      { label: "Work", href: "/work" },
      { label: "Process", href: "/process" },
      { label: "Pricing", href: "/pricing" },
      { label: "Contact", href: "/contact" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative border-t border-white/10 mt-10">
      <div className="container-apex py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <span className="inline-flex items-center justify-center w-9 h-9 rounded-xl bg-apex-orange/15 border border-apex-orange/30">
                <TrendingUp className="w-4.5 h-4.5 text-apex-orange" strokeWidth={2.2} />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading font-extrabold text-xl tracking-tight">
                  APEX<span className="text-apex-orange">.</span>
                </span>
                <span className="mt-0.5 text-[9px] uppercase tracking-[0.24em] text-white/55 font-semibold">
                  Innovation Solutions
                </span>
              </span>
            </Link>
            <p className="text-sm font-heading font-semibold text-white" data-testid="footer-legal-name">APEX Innovation Solutions</p>
            <p className="text-xs text-apex-slate max-w-xs leading-relaxed mt-1">
              A registered digital marketing and web design agency helping businesses grow through websites, SEO, AEO &amp; GEO.
            </p>

            <div className="mt-5 space-y-2.5">
              <a href={`tel:${CONTACT_BLOCK.phone_tel}`} data-testid="footer-phone" className="flex items-center gap-2 text-sm text-white/75 hover:text-white transition-colors">
                <Phone className="w-3.5 h-3.5 text-apex-orange" strokeWidth={2} />
                {CONTACT_BLOCK.phone}
              </a>
              <a href={`mailto:${CONTACT_BLOCK.business_email}`} data-testid="footer-email-business" className="flex items-center gap-2 text-sm text-white/75 hover:text-white transition-colors">
                <Mail className="w-3.5 h-3.5 text-apex-cyan" strokeWidth={2} />
                {CONTACT_BLOCK.business_email}
              </a>
              <a href="mailto:News@apexinnovationsolutions.com" data-testid="footer-email-news" className="flex items-center gap-2 text-sm text-white/75 hover:text-white transition-colors">
                <Mail className="w-3.5 h-3.5 text-apex-purpleSoft" strokeWidth={2} />
                News@apexinnovationsolutions.com
              </a>
            </div>

            <div className="mt-5 space-y-3">
              <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-3.5" data-testid="footer-address-in-1">
                <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-widest text-white/50 font-bold mb-2">
                  <span aria-hidden>🇮🇳</span> India Office · 1
                </div>
                <div className="text-[13px] text-white/80 font-semibold leading-tight">APEX Innovation Solutions</div>
                <div className="flex items-start gap-1.5 mt-1 text-[11px] text-white/60 leading-relaxed">
                  <MapPin className="w-3 h-3 text-apex-pink mt-0.5 shrink-0" strokeWidth={2} />
                  <address className="not-italic">
                    2nd Floor, 113, Shri Kuber Complex,<br />
                    Near Indo Canadian Bus Services,<br />
                    Jalandhar, Punjab 144001, India
                  </address>
                </div>
              </div>

              <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-3.5" data-testid="footer-address-in-2">
                <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-widest text-white/50 font-bold mb-2">
                  <span aria-hidden>🇮🇳</span> India Office · 2
                </div>
                <div className="text-[13px] text-white/80 font-semibold leading-tight">APEX Innovation Solutions</div>
                <div className="flex items-start gap-1.5 mt-1 text-[11px] text-white/60 leading-relaxed">
                  <MapPin className="w-3 h-3 text-apex-pink mt-0.5 shrink-0" strokeWidth={2} />
                  <address className="not-italic">
                    H No. 71/G, Gate No. 12, Jyoti Nagar,<br />
                    Jalandhar–1, PO: Jalandhar City,<br />
                    District: Jalandhar, Punjab – 144001
                  </address>
                </div>
              </div>

              <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-3.5" data-testid="footer-address-us">
                <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-widest text-white/50 font-bold mb-2">
                  <span aria-hidden>🇺🇸</span> United States Office
                </div>
                <div className="text-[13px] text-white/80 font-semibold leading-tight">APEX Innovation Solutions LLC</div>
                <div className="flex items-start gap-1.5 mt-1 text-[11px] text-white/60 leading-relaxed">
                  <MapPin className="w-3 h-3 text-apex-pink mt-0.5 shrink-0" strokeWidth={2} />
                  <address className="not-italic">
                    7533 S Center View Ct, Ste 210,<br />
                    West Jordan, UT 84084, USA
                  </address>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-2 mt-6">
              {[
                { Icon: Twitter, label: "twitter" },
                { Icon: Linkedin, label: "linkedin" },
                { Icon: Instagram, label: "instagram" },
                { Icon: Github, label: "github" },
              ].map(({ Icon, label }) => (
                <a
                  key={label}
                  href="#"
                  aria-label={label}
                  data-testid={`social-${label}`}
                  className="w-10 h-10 rounded-full border border-white/10 bg-white/[0.03] hover:bg-white/[0.08] flex items-center justify-center transition-colors"
                >
                  <Icon className="w-4 h-4 text-white/80" strokeWidth={1.75} />
                </a>
              ))}
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title} className="md:col-span-2">
              <div className="text-xs font-bold uppercase tracking-[0.24em] text-white/60 mb-4">{c.title}</div>
              <ul className="space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.href} className="text-sm text-white/75 hover:text-white transition-colors">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-2">
            <div className="text-xs font-bold uppercase tracking-[0.24em] text-white/60 mb-4">Legal</div>
            <ul className="space-y-2.5">
              {LEGAL_INDEX.map((l) => (
                <li key={l.slug}>
                  <Link
                    to={`/legal/${l.slug}`}
                    data-testid={`footer-legal-${l.slug}`}
                    className="text-sm text-white/75 hover:text-white transition-colors"
                  >
                    {l.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs font-bold uppercase tracking-[0.24em] text-white/60 mb-4">Get started</div>
            <Link to="/contact" className="text-sm text-white/85 hover:text-white block">
              Book a strategy call →
            </Link>
            <Link to="/pricing" className="text-sm text-white/60 hover:text-white block mt-2">
              View packages
            </Link>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/50">
          <p>© {new Date().getFullYear()} APEX Innovation Solutions. All rights reserved.</p>
          <div className="flex items-center gap-6 flex-wrap">
            {LEGAL_INDEX.slice(0, 4).map((l) => (
              <Link key={l.slug} to={`/legal/${l.slug}`} className="hover:text-white">
                {l.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
